import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import { quest6Data, quest6Selected } from '../../../Redux/Slices/selectedOptionSlice';
import './F20.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame20() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let quest6 = useSelector(quest6Data);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);

    if (isLoading === true) {
        return (<div className="F19_image"></div>)
    } else {
        return (
            <div className="F20_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F20_entryBox">
                    <div className="F20_heading">
                        {language === 'english' ?
                            <p className="F20_headingEnglish">What advice should Sofia give to Saira</p>
                            :
                            <p className="F20_headingUrdu">ایسی صورتحال میں صوفیہ کو سائرا کو کیا نصحیت کرنی چاہیئے۔</p>
                        }
                    </div>

                    <div className="F20_options">
                        <div onClick={() => { dispatch(quest6Selected('A'), dispatch(pageUp())) }} className={language === 'english' ? "F20_option" : "F20_optionUrdu"}>
                            {language === 'english' ? `A. ${quest6.headingEnglish.A}` : `${quest6.headingUrdu.A}`}
                        </div>

                        <div onClick={() => { dispatch(quest6Selected('B'), dispatch(pageUp())) }} className={language === 'english' ? "F20_option" : "F20_optionUrdu"}>
                            {language === 'english' ? `B. ${quest6.headingEnglish.B}` : `${quest6.headingUrdu.B}`}
                        </div>
                    </div>

                    <div className="F20_timeline">
                        <div className='F20_timelineBar'>
                            <div className='F20_timelineFill'></div>
                            <span className='F20_timelineText'>15/16</span>
                        </div>
                    </div>

                    <div className="F20_nextFrames">
                        <div className="F20_nextFrame1"></div>
                        <div className="F20_nextFrame2"></div>
                        <div className="F20_nextFrame3"></div>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame20;